import React from 'react';
import {useTheme} from '@packages/utilities/styled';
import {LockIcon} from '@packages/systems/spring';
import {rightSidebarLabelWidth} from '@packages/systems/design-system/constants/DesignerUI';

export default function LockedDynSource({source}: {source: string}) {
  const theme = useTheme();

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `${rightSidebarLabelWidth}px minmax(0, auto)`,
        gridGap: theme.gutters.x8,
        alignItems: 'center',
        paddingTop: 4,
        paddingBottom: 4,
      }}
    >
      <span>Source</span>
      <div
        style={{
          background: theme.colors.dynamicBackground,
          padding: 8,
          height: 24,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          border: `${theme.control.borderWidth}px ${theme.control.borderStyle} ${theme.control.borderColor}`,
          borderRadius: theme.control.borderRadius,
        }}
      >
        {source}
        <LockIcon size={12} />
      </div>
    </div>
  );
}
